import React, { Component } from "react";
import __ from "lodash";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import LoaderModal from "../../../../modal/LoaderModal";
import { CONFIG } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import { Row, Col, Alert, Table } from "react-bootstrap";
import "../tryout/circlebar.css";
import "../tryout/reportsbmptn.css";
import { TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";

class RekomendasiSnmptn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            listRekom: [],
            listNonRekom: [],
            detail: [],
        };
    }

    async componentDidMount() {
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchData();
        }
    }

    fetchData = async () => {
        const param = this.props.match.params;
        let qString = {
            idKelas: param.idKelas,
            idKelasParalel: param.idKelasParalel,
            kodeTahunAjaran: param.kodeTahunAjaran1 + "/" + param.kodeTahunAjaran2,
        };

        const response = await accountManagement
            .get(CONFIG.REPORT_REKOMENDASI_SNMPTN, {
                params: qString,
            })
            .catch(function (error) {
                console.log(error);
            });
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    listRekom: response.data.data.listRekomendasi,
                    listNonRekom: response.data.data.listNonRekomendasi,
                    detail: response.data.data,
                });
            }
            this.setState({ isFetching: false });
        }
        this.setState({ isFetching: false });
    };

    renderTableRekom() {
        let { listRekom } = this.state;
        if (!__.isEmpty(listRekom)) {
            return (
                <div className="card-profile" style={{ padding: '0px', borderRadius: '4px' }}>
                    <div class="Table">
                        <div class="Heading">
                            <div class="Cell">
                                <p>No</p>
                            </div>
                            <div class="Cell">
                                <p>Nama Siswa</p>
                            </div>
                            <div class="Cell">
                                <p>PTN</p>
                            </div>
                            <div class="Cell">
                                <p>Prodi</p>
                            </div>
                            <div class="Cell">
                                <p>Rataan Rapor</p>
                            </div>
                            <div class="Cell">
                                <p>NRM</p>
                            </div>
                            <div class="Cell">
                                <p>Indeks Kewilayahan</p>
                            </div>
                            <div class="Cell">
                                <p>Prestasi</p>
                            </div>
                            <div class="Cell">
                                <p>Mata Pelajaran Kompetensi</p>
                            </div>
                            <div class="Cell">
                                <p>Urutan Prodi & PTN</p>
                            </div>
                            <div class="Cell">
                                <p>Kategori</p>
                            </div>
                        </div>
                        {listRekom.map((val, i) => (
                            <div class="Row">
                                <div class="Cell">
                                    <p>{i + 1}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.namaSiswa}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.namaPtn}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.namaProdi}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.nilaiRataanRaport}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.nilaiRataan}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.indeksKewilayahan}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.prestasi}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.mapelKopetensi}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.urutanProdiPtn}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.analisa}</p>
                                </div>
                            </div>
                        ))}
                    </div>


                </div>
            );
        } else {
            return (
                <Row>
                    <Col>
                        <b>Data tidak tersedia</b>
                    </Col>
                </Row>
            );
        }
    }

    renderTableNonRekom() {
        let { listNonRekom } = this.state;
        if (!__.isEmpty(listNonRekom)) {
            return (
                <div className="card-profile" style={{ padding: '0px', borderRadius: '4px' }}>
                    <div class="Table">
                        <div class="Heading">
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>No</p>
                            </div>
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>Nama Siswa</p>
                            </div>
                        </div>
                        {listNonRekom.map((val, i) => (
                            <div class="Row">
                                <div class="Cell" style={{ textAlign: 'left' }}>
                                    <p>{i + 1}</p>
                                </div>
                                <div class="Cell" style={{ textAlign: 'left' }}>
                                    <p>{val.namaSiswa}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }
    }

    render() {
        const { detail, listNonRekom } = this.state;
        return (
            <div className="container-fluid" style={{ paddingBottom: "50px" }}>
                <LoaderModal isFetching={this.state.isFetching} />
                <div className="stat-wrapper">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>01</span>
                        </div>
                        <div className="pnl-date">
                            <span>https://eduprime.co.id</span>
                        </div>
                    </div>
                    <Row style={{ marginBottom: '40px' }}>
                        <Col>
                            <div className="text-header" style={{ padding: '0px' }}>
                                <div className="title-header2">REKAPITULASI USS SNBP</div>
                            </div>
                        </Col>
                        <Col style={{ textAlign: 'right' }}>
                            <div className="image-header">
                                <div className="logo-edu">
                                    <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} style={{ width: '200px' }} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {/* <hr className="garis" /> */}
                    <Row>
                        <Col>
                            <b style={{ float: "right" }}>{detail.namaSekolah}</b>
                        </Col>
                    </Row>
                    &nbsp;
                    <Row>
                        <Col>
                            <b style={{ fontSize: '20px', fontWeight: 700 }}>Data Rekomendasi Siswa</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>{this.renderTableRekom()}</Col>
                    </Row>
                    &nbsp;
                    {!__.isEmpty(listNonRekom) && (
                        <>
                            <Row>
                                <Col>
                                    <b style={{ fontSize: '20px', fontWeight: 700 }}>
                                        Data Siswa yang belum memilih PTN tujuan
                                    </b>
                                </Col>
                            </Row>
                            <Row>
                                <Col>{this.renderTableNonRekom()}</Col>
                            </Row>
                        </>
                    )}
                    <div id="btn_print">
                        <div className="fixed_button">
                            <button className="btn btn-outline-primary btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                Print
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(RekomendasiSnmptn);
